"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const library_airtable_cms_icon_1 = __importDefault(require("@talus-analytics/library.airtable.cms-icon"));
const IconHolder = styled_components_1.default.foreignObject `
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CMSPlotIcon = react_1.default.forwardRef((_a, ref) => {
    var { x, y, height, width, name, color, hoverColor, noEmitError = false } = _a, props = __rest(_a, ["x", "y", "height", "width", "name", "color", "hoverColor", "noEmitError"]);
    return (react_1.default.createElement(IconHolder, Object.assign({}, props, { x: x - width / 2, y: y - height / 2 }),
        react_1.default.createElement(library_airtable_cms_icon_1.default, Object.assign({ ref: ref, style: { width, height } }, { name, color, hoverColor, noEmitError }))));
});
exports.default = CMSPlotIcon;
//# sourceMappingURL=CMSPlotIcon.js.map